import { render, staticRenderFns } from "./SocialStatusLabel.vue?vue&type=template&id=457c4423&scoped=true&"
import script from "./SocialStatusLabel.vue?vue&type=script&lang=js&"
export * from "./SocialStatusLabel.vue?vue&type=script&lang=js&"
import style0 from "./SocialStatusLabel.vue?vue&type=style&index=0&id=457c4423&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457c4423",
  null
  
)

export default component.exports